import {Note} from 'notebook/util/NoteUtilConstants';

/**
 * Returns true when the item being pasted was cut (not copied) from the same document it is being
 * pasted into. In that case provenance UUIDs should be preserved because the item is logically the
 * same — it was just moved.
 *
 * Shared between structured tables and note-linked groups paste flows.
 *
 * @param sourceFileId  - The file/document the item originated from (e.g. `item.fileId`).
 * @param doesNoteIncludeItemUuid - A predicate that returns true when the note still contains an
 *   item with the given provenance UUID. When the item was *cut*, the note no longer contains it.
 */
export default function isCutAndPasteWithinSameDocument(
  note: Note | undefined,
  destinationFileId: string | undefined,
  sourceFileId: string | undefined,
  provenanceUuid: string,
  doesNoteIncludeItemUuid: (note: Note, uuid: string) => boolean
): boolean {
  return Boolean(
    destinationFileId &&
    sourceFileId === destinationFileId &&
    note &&
    // eslint-disable-next-line benchlint/no-in-operator
    'noteParts' in note &&
    !doesNoteIncludeItemUuid(note, provenanceUuid)
  );
}
